import { Controller } from "@hotwired/stimulus";

export default class RoomsController extends Controller {
  static targets = ["step1", "step2"];

  nextStep() {
    const form = this.element;
    if (!$(form).valid()) return;

    this.step1Target.classList.add("d-none");
    this.step2Target.classList.remove("d-none");
  }

  previousStep() {
    this.step2Target.classList.add("d-none");
    this.step1Target.classList.remove("d-none");
  }

  validateMembers(event) {
    const selectedUsers = this.element.querySelectorAll(
      "input[name=\"room[user_ids][]\"]"
    );

    const error = this.element.querySelector(".target_user_error");

    if (selectedUsers.length < 2) {
      event.preventDefault();
      error.classList.remove("d-none");
      return false;
    }

    error?.classList.add("d-none");
    this.showSubmitLoader();

    return true;
  }

  showSubmitLoader() {
    const submitButton = this.element.querySelector('button[type="submit"]');

    if (!submitButton) return;

    submitButton.disabled = true;
    this.showLoader(submitButton);
    this.hideSubmitLabel(submitButton);
    this.disableParticipantSelection();
  }

  showLoader(submitButton) {
    const loader = submitButton.querySelector(".button-loader-spinner");
    loader?.classList.remove("d-none");
  }

  hideSubmitLabel(submitButton) {
    const label = submitButton.querySelector(".translated-settings-label__text");
    label?.classList.add("invisible");
  }

  disableParticipantSelection() {
    const userSelector = this.element.querySelector('[data-controller="user-selector"]');
    if (!userSelector) return;

    const controls = userSelector.querySelectorAll('input:not([type="hidden"]), button, select, textarea');
    for (const control of controls) {
      control.disabled = true;
    }
  }
}